import { Component, OnInit } from '@angular/core';
import { DownloadService } from '../dashboards/arcon-dashboard/download.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'logzy-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

  constructor(private downloadService: DownloadService,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length > 0) {
        if ('download_url' in params) {
          this.getDocumentToken(params['download_url'])
        }
      }
    })
  }

  getDocumentToken(download_url: string) {
    this.downloadService.getDocumentToken({ download_url: download_url }).subscribe(res => {
      this.downloadDocument(download_url, res.token)
    });
  }

  downloadDocument(url: string, doc_token: string) {
    this.downloadService.getDocumentBlob(url, doc_token).subscribe({
      next: response => {
        const contentDisposition = response.headers.get('Content-Disposition');

        const blob = response.body;
        // @ts-ignore
        const downloadURL = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = this.getFileNameFromContentDisposition(contentDisposition);
        link.click();
        window.URL.revokeObjectURL(downloadURL);
        setTimeout(() => {
          window.close()
        }, 3000)
      },
    });
  }

  private getFileNameFromContentDisposition(contentDisposition: string | null): string {
    let defaultFileName = 'Arthakosh_file'
    if (!contentDisposition) {
      return defaultFileName;
    }

    const result = contentDisposition.split(";")

    const keyValuePairs: { [key: string]: string | null } = {};

    const trimQuotes = (value: string | null) => {
      if (value && value.startsWith('"') && value.endsWith('"')) {
        return value.slice(1, -1);
      }
      return value;
    };

    result.filter(str => str.trim() !== '').forEach(item => {
      const [key, value] = item.split('=');
      keyValuePairs[key.trim()] = trimQuotes(value ? value.trim() : null);
    });

    if ('filename' in keyValuePairs) {
      return keyValuePairs['filename'] != null ? keyValuePairs['filename'] : defaultFileName;
    } else {
      return defaultFileName;
    }
  }
}

